import { gql } from "apollo-boost";

export const GQL_GET_CART = gql`
  query {
    getCart {
      updated_at
      papers {
        id
        paperContents {
          content {
            articleTitle
            journalInfo {
              pubdate
            }
            medlineJournalInfo {
              medlineTA
            }
          }
          journal {
            nImpactFactor
          }
        }
      }
    }
  }
`;

export const GQL_ADD_ITEM_TO_CART = gql`
  mutation($id: String!) {
    addItemToCart(id: $id) {
      updated_at
      papers {
        id
        paperContents {
          content {
            articleTitle
            journalInfo {
              pubdate
            }
            medlineJournalInfo {
              medlineTA
            }
          }
          journal {
            nImpactFactor
          }
        }
      }
    }
  }
`;

export const GQL_ADD_ITEMS_TO_CART = gql`
  mutation($ids: [String!]!) {
    addItemsToCart(ids: $ids) {
      updated_at
      papers {
        id
        paperContents {
          content {
            articleTitle
            journalInfo {
              pubdate
            }
            medlineJournalInfo {
              medlineTA
            }
          }
          journal {
            nImpactFactor
          }
        }
      }
    }
  }
`;

export const GQL_UPDATE_ITEMS_IN_CART = gql`
  mutation($ids: [String!]!) {
    updateItemsInCart(ids: $ids) {
      updated_at
      papers {
        id
        paperContents {
          content {
            articleTitle
            journalInfo {
              pubdate
            }
            medlineJournalInfo {
              medlineTA
            }
          }
          journal {
            nImpactFactor
          }
        }
      }
    }
  }
`;

export const GQL_REMOVE_ITEM_FROM_CART = gql`
  mutation($id: String!) {
    removeItemFromCart(id: $id) {
      updated_at
      papers {
        id
        paperContents {
          content {
            articleTitle
            journalInfo {
              pubdate
            }
            medlineJournalInfo {
              medlineTA
            }
          }
          journal {
            nImpactFactor
          }
        }
      }
    }
  }
`;
